// style
import './style/help.css'
// hook
import { useEffect, useState } from "react";
// form
import { FieldErrors, useForm } from 'react-hook-form';
// @ts-ignore
import Cookies from "js-cookie";
// toast
import { toast, ToastContainer } from "react-toastify";
import { toastOptions } from "../../../features/toast/toast";
// action
import step from "../../../features/step/step";
// link
// use query
import { useMutation, useQuery } from "@tanstack/react-query";
import { sendOtpMoghavemat } from "../../../services/moghavemat/otp/sendOtpMoghavemat";
import { registerOtpMoghavemat } from "../../../services/moghavemat/otp/registerOtpMoghavemat";
import { paymentMoghavemat } from "../../../services/moghavemat/payment/paymentMoghavemat";
import { getProvince } from "../../../services/hamiyan/location/getProvince";
import { getCity } from "../../../services/hamiyan/location/getCity";
// action
import { formatNumber } from "../../../features/formatNumber/formatNumber";
import { persianToEnglishDigits } from "../../../features/persianToEnglish/convertEnglish";
// axios
import axios from "axios";
// id
import { setIpOtp } from "../../../services/moghavemat/otp/setIp";
// react select
import Select from 'react-select';
import { paymentHamiyan } from "../../../services/hamiyan/payment/paymentHamiyan";

const Hamiyan = () => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [value, setValue] = useState<string>("");
    const [newData, setData] = useState<any>();
    const [code, setCode] = useState<any>();
    const [userCode, setUserCode] = useState<any>()
    const [ip, setIp] = useState<string>("");
    const [selectedOption, setSelectedOption] = useState(null);
    const { data: provinces }: any = useQuery<any>({
        queryKey: ['categories'],
        queryFn: getProvince
    });
    const [city, setCity] = useState<any>(null);
    const [selectCity, setSelectCity] = useState<any>(null);
    const { register, handleSubmit }: any = useForm<any>({
        defaultValues: {
            phoneNumber: Cookies.get('mobile_number'),
        },
    });
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const formattedValue = formatNumber(e.target.value);
        setValue(formattedValue);
    };
    const onError = (errors: FieldErrors<any>) => {
        const uniqueErrorMessages = new Set<string>();
        Object.values(errors).forEach((error) => {
            if (error?.message) {
                uniqueErrorMessages.add(error.message as string);
            }
        });
        uniqueErrorMessages.forEach((message) => {
            toast.error(message, toastOptions);
        });
        // @ts-ignore
        if (errors?.text) {
            toast.error("یکی از فیلدای کد رو فراموش کردی", toastOptions);
        }
    };
    const Mutation = useMutation({
        mutationFn: paymentHamiyan,
        onSuccess: data => {
            setCode(data.message);
            setTimeout(() => {
                document.getElementById('submit-btn-form')!.click();
            }, 2000)
        },
        onError: data => {
            toast.error("اطلاعات را درست وارد نمایید.", toastOptions);
        }
    });
    const OtpMutation = useMutation({
        mutationFn: sendOtpMoghavemat,
        onSuccess: data => {
            toast.success('کد یکبار مصرف از طریق پیامک برای شما ارسال شد.', toastOptions);
        },
        onError: data => {
            toast.error("لطفا دوباره تلاش کنید.", toastOptions);
        }
    });
    const RegisterMutation = useMutation({
        mutationFn: registerOtpMoghavemat,
        onSuccess: data => {
            toast.success('کد با موفقیت تایید شد.', toastOptions);
            const province = provinces.find((province: any) => province.id == selectedOption);
            const provinceName = province ? province.name : '';
            let paymentData: any = {
                amount: newData.amount.replace(/,/g, ""),
                cellNumber: newData.phoneNumber,
                province: provinceName,
                city: selectCity,
            }
            Cookies.set('amount', paymentData.amount)
            Cookies.set('mobileNumber', paymentData.cellNumber)
            Mutation.mutate(paymentData)
        },
        onError: data => {
            toast.error("کد وارد شده صحیح نمی باشد", toastOptions);
        }
    });
    const IpMutation = useMutation({
        mutationFn: setIpOtp,
    });
    const CityMutation = useMutation({
        mutationFn: getCity,
        onSuccess: data => {
            setCity(data)
        },
    });
    const sendOtpMessage = () => {
        let regex = new RegExp(/(^09[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/);
        let second_regex = new RegExp(/(^9[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/)
        let value = (document.getElementById('telephone') as HTMLInputElement)!.value;
        let result = regex.test(((document.getElementById('telephone') as HTMLInputElement)!.value));
        let second_result = second_regex.test(((document.getElementById('telephone') as HTMLInputElement)!.value));
        let status = 0;
        // @ts-ignore
        let amount = document.getElementById('price')!.value;
        amount = amount.replace(/,/g, "")
        amount = parseInt(amount, 10);
        if (amount < 50000) return toast.error("مبلغ نباید کمتر از 50 هزار ریال باشد.", toastOptions);
        else if (amount > 2000000000) return toast.error("مبلغ نباید بیشتر از ۲ میلیارد ریال باشد", toastOptions);
        if (amount < 50000 || amount > 2000000000 || isNaN(amount)) {
            status = 1;
        }
        // eslint-disable-next-line no-mixed-operators
        if (value != '' && status === 0 && selectCity != null && selectedOption != null && result || second_result) {
            let data: any = {
                phoneNumber: value,
                sessionId: String(userCode),
                ip: ip,
                Code: String(15000),
            }
            OtpMutation.mutate(data)
            setIsDisabled(true);
            setTimeout(() => {
                setIsDisabled(false);
            }, 120000);
        } else {
            toast.error("اطلاعات را به درستی وارد نمایید.", toastOptions);
        }
    }
    const onSubmit = (data: any) => {
        setData(data);
        let values = document.getElementsByClassName('step-input');
        let newValue: any;
        for (let i = 0; i < values.length; i++) {
            // @ts-ignore
            newValue += values[i].value;
        }
        let result = newValue.startsWith("undefined")
            ? [undefined, ...newValue.slice(9).split('').map(Number)]
            : newValue.split('').map(Number);
        result = result.reverse();
        result.pop();
        result = result.join('')
        let registerData: any = {
            phoneNumber: data.phoneNumber,
            text: result,
        }
        let amount = data.amount.replace(/,/g, "")
        amount = parseInt(amount, 10)
        if (amount < 50000) return toast.error("مبلغ نباید کمتر از 50 هزار ریال باشد.", toastOptions);
        else if (amount > 2000000000) return toast.error("مبلغ نباید بیشتر از ۲ میلیارد ریال باشد", toastOptions);
        else {
            RegisterMutation.mutate(registerData);
        }
    };
    let show: number = 0;
    let showSecond: number = 0;
    const checkPrice = (event: any) => {
        let amount = event.target.value.replace(/,/g, "")
        amount = parseInt(amount, 10)
        if (amount < 50000) {
            if (show < 4) {
                toast.error("مبلغ نباید کمتر از 50 هزار ریال باشد.", toastOptions)
            }
            show++;
        } else if (amount > 2000000000) {
            if (showSecond < 4) {
                toast.error("مبلغ نباید بیشتر از ۲ میلیارد ریال باشد", toastOptions)
            }
            showSecond++;
        }
    }
    const checkKey = (e: any) => {
        const englishValue = persianToEnglishDigits(e.target.value);
        e.target.value = englishValue;
        let values = document.getElementsByClassName('step-input');
        // @ts-ignore
        const allFilled = Array.from(values).every(input => input.value.trim() !== '');
        if (allFilled) {
            document.getElementById('submit-form')!.click()
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let newCode: any, codeStaus: number = 0;
    const fetchIP = async () => {
        try {
            const response = await axios.get("https://api.ipify.org?format=json");
            setIp(response.data.ip);
            let ipData: any = {
                ip: response.data.ip,
                sessionId: newCode,
            }
            if (codeStaus === 0) {
                IpMutation.mutate(ipData)
            }
            codeStaus = 1
        } catch (error) {
            console.error("Error fetching IP:", error);
        }
    };
    const generateRandomCode = () => {
        let digits = new Set<number>();
        while (digits.size < 6) {
            digits.add(Math.floor(Math.random() * 10));
        }
        let result = Array.from(digits).join("");
        newCode = result;
        setUserCode(result);
    };
    const showCity = (id: any) => {
        setSelectedOption(id);
        CityMutation.mutate(id);
    }
    useEffect(() => {
        generateRandomCode()
        fetchIP();
    }, []);
    if (Mutation.isPending || Mutation.isSuccess) {
        document.body.classList.remove('bg-body')
        document.body.classList.add('bg-gradiant');
        return (
            <>
                <section className={'container h-100 pb-3'}>
                    <div className={'row align-items-center h-100 justify-content-center'}>
                        <div className={'col-lg-4 col-md-7 col-12 text-center'}>
                            <h4 className={'text-white fw-bold'}>در حال هدایت به درگاه پرداخت...</h4>
                        </div>
                    </div>
                    <form method={'post'} action={'https://sep.shaparak.ir/OnlinePG/OnlinePG'}>
                        <input type={'hidden'} name={'Token'} value={code} />
                        <input type={'text'} name={'GetMethod'} value={''} className={'d-none'} />
                        <button type={'submit'} className={'d-none'} id={'submit-btn-form'}></button>
                    </form>
                </section>
            </>
        )
    } else {
        document.body.classList.add('bg-body')
        document.body.classList.remove('bg-gradiant');
        return (
            <>
                <article className={'moghavemat container-fluid h-100 overflow-x-hidden'}>
                    <form id={'form'} className={'h-100'} onSubmit={handleSubmit(onSubmit, onError)}>
                        <div className="row justify-content-center align-items-center h-100">
                            <div className="col-12 mb-md-0 mb-4">
                                <div className={'help-row'}>
                                    <header className={'container py-0 mb-1 text-center'}>
                                        <div className={'row justify-content-center'}>
                                            <div className={'col-lg-4 col-md-6 col-12'}>
                                                <div className={'px-4'}>
                                                    <img className={'img-fluid logo'}
                                                        src={require('./../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} />
                                                </div>
                                                <p className={'card-text text-center text-white fw-bold mt-3 mb-2'}>
                                                    سامانه ملی امن، سریع و آسان تراکنش ایران
                                                </p>
                                                <h4 className={'text-centerfw-bold text-white mb-2'}>
                                                    پویش مردمی حامیان مقاومت
                                                </h4>
                                            </div>
                                        </div>
                                    </header>
                                    <div className={'row justify-content-center'}>
                                        <div className={'col-lg-4 col-md-6 col-12'}>
                                            <fieldset className={'mt-md-3 mt-1 px-3'}>
                                                <input
                                                    value={value}
                                                    id={'price'}
                                                    type={'tel'}
                                                    maxLength={12}
                                                    placeholder={'مبلغ به ریال'}
                                                    onMouseLeave={(e) => checkPrice(e)}
                                                    onTouchEnd={(e) => checkPrice(e)}
                                                    className={'form-control login-input'}
                                                    {...register('amount', {
                                                        required: 'فیلد مبلغ الزامی است.',
                                                        onChange: handleChange,
                                                    })}
                                                />
                                            </fieldset>
                                            <fieldset className={'px-3 mt-3'}>
                                                <Select
                                                    placeholder={'استان'}
                                                    defaultValue={selectedOption}
                                                    getOptionLabel={(option: any) => option.name}
                                                    getOptionValue={(option: any) => option.id}
                                                    onChange={(option: any) => showCity(option.id)}
                                                    options={provinces}
                                                />
                                            </fieldset>
                                            <fieldset className={'px-3 mt-3'}>
                                                <Select
                                                    placeholder={'شهر'}
                                                    onChange={(option: any) => setSelectCity(option.name)}
                                                    getOptionLabel={(option: any) => option.name}
                                                    getOptionValue={(option: any) => option.name}
                                                    options={city}
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <div className={'d-flex justify-content-center mt-md-3 mt-3'}>
                                                    <input
                                                        type={'tel'}
                                                        id={'telephone'}
                                                        maxLength={11}
                                                        className={'w-75 form-control login-input'}
                                                        placeholder={'شماره موبایلتون رو وارد کنید...'}
                                                        {...register('phoneNumber', { required: 'شماره تلفن الزامی ست.' })}
                                                    />
                                                    <button
                                                        disabled={isDisabled}
                                                        type={'button'}
                                                        onClick={() => sendOtpMessage()}
                                                        id={'signup-btn'}
                                                        className={isDisabled ? 'form-btn login-btn text-black disabled-form fw-bold font-medium' : 'form-btn login-btn text-black fw-bold font-medium'}>
                                                        {OtpMutation.isPending ? 'درحال ارسال' : (
                                                            <>
                                                                {isDisabled ? `ارسال شد...` : "دریافت کد"}
                                                            </>
                                                        )}
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12.7801 6.31005C15.6501 4.66005 18.0001 6.01005 18.0001 9.33005V12V14.67C18.0001 17.98 15.6501 19.34 12.7801 17.68L10.4701 16.34L8.16007 15C5.29007 13.34 5.29007 10.63 8.16007 8.97005"
                                                                stroke="#171717" strokeWidth="2" strokeMiterlimit="10"
                                                                strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </fieldset>
                                            <fieldset className={'px-5'}>
                                                <div className={'row mt-3'}>
                                                    {Array.from({ length: 4 }, (_, index) => (
                                                        <fieldset key={index} className={'col-3'}>
                                                            <input
                                                                type="tel"
                                                                key={index}
                                                                maxLength={1}
                                                                onInput={(e) => checkKey(e)}
                                                                disabled={index < 3}
                                                                id={`digit${index}`}
                                                                className={'form-control birthDay step-code step-input font-small ltr'}
                                                                onKeyDown={(e) => step(e, index, `digit`)}
                                                                {...register(`text.${index + 1}`, { required: 'یکی از فیلدای کد رو فراموش کردی' })}
                                                            />
                                                        </fieldset>
                                                    ))}
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'col-12 d-none'}>
                                <div className={'row justify-content-center h-100 align-items-end btn-row'}>
                                    <div className={'col-8'}>
                                        <div className={'justify-content-center d-flex'}>
                                            <button
                                                id={'submit-form'}
                                                className={'btn d-none btn-site rounded rounded-pill fw-bold px-3 position-relative'}>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </article>
                <ToastContainer />
            </>
        )
    }
}

export default Hamiyan;